import 'fullscreen-api-polyfill';
import device from "current-device";
import * as is from 'utilities/is';
import { insideIFrame } from 'utilities/dom';
import { DEVICE_TYPES, ORIENTATIONS } from 'constants';

export const HY_TOOLS_MATCHER = /^http(s)?\:\/\/hyhcs(-\w+)?\.hapyak\.com/;

export const pageInformation = (() => {
    let host, href, search, referringDomain;

    try {
        if (window.top && window.top.location) {
            host = window.top.location.host;
            href = window.top.location.href;
            search = window.top.location.search;
        }
    } catch (e) {}

    // couldn't access cross domain parent information
    if (!href) {
        const tag = document.createElement('a');

        href = tag.href = window.parent !== window ? document.referrer : window.location.host;
        host = tag.host;
        search = tag.search;
    }

    referringDomain = (/\/\/([^/]+)/i).exec(document.referrer);

    if (referringDomain && referringDomain.length) {
        referringDomain = referringDomain[1];
    }

    return {
        host,
        href,
        search,
        referringDomain
    };
})();

export const fullscreen = (() => {
    let inFakeFullscreen = false,
        changeCallbacks = [],
        initialBGColor = '';

    const fullscreenInterface = {
        supportsAPI: document.fullscreenEnabled ? true : false,
        onChange: cb => changeCallbacks.push(cb),
        offChange: cb => changeCallbacks.filter(callback => callback !== cb),
        enter(el) {
            if (this.supportsAPI) {
                if (is.fn(el.requestFullscreen)) {
                    el.requestFullscreen();
                }
            } else {
                console.trace('adding fake fullscreen');
                el.classList.add('fake-fullscreen');
                inFakeFullscreen = true;

                /* ensure "notched" regions of screen match fullscreen background */ 
                initialBGColor = document.body.style.backgroundColor;
                document.body.style.backgroundColor = 'black';

                fullscreenChanged();
            }

        },
        exit(el) {
            if (this.supportsAPI) {
                if (is.fn(document.exitFullscreen)) {
                    document.exitFullscreen();
                }
            } else {
                console.trace('removing fake fullscreen');
                el.classList.remove('fake-fullscreen');
                inFakeFullscreen = false;

                if (initialBGColor) {
                    document.body.style.backgroundColor = initialBGColor;
                } else {
                    document.body.style.backgroundColor = '';
                }

                fullscreenChanged();
            }
            
        },
        get inFullscreen() {
            if (this.supportsAPI) {
                if (is.defined(document.fullscreenElement)) {
                    return !!document.fullscreenElement;
                }
            } else {
                return inFakeFullscreen;
            }
        }
    };

    function fullscreenChanged(event) {
        changeCallbacks.forEach(cb => cb());
    }

    document.addEventListener('fullscreenchange', fullscreenChanged);

    return fullscreenInterface;
})();

export const querystring = (query = '') => {
    const params = new URLSearchParams(query);
    return Object.fromEntries(params);
};

export const LEGACY_IE = (() => {
    const ua = navigator.userAgent.toLowerCase(),
        isWindows7 = /windows nt 6.1/.test(ua);
    return isWindows7 && /msie|trident/.test(ua);
})();

export const requiresFlash = videoSource => (
    LEGACY_IE && is.hls(videoSource)
);

export const prefixedQueryParams = (prefix = '', subject = pageInformation.search) => {
    const params = querystring(subject);

    return (
        Object
            .keys(params)
            .filter(p => p.startsWith(prefix))
            .reduce((reduced, p) => {
                reduced[p.replace(prefix, '')] = params[p];
                return reduced;
            }, {})
    );
};

export const deviceType = (() => {
    if (device.tablet()) {
        return DEVICE_TYPES.TABLET;
    } else if (device.mobile()) {
        return DEVICE_TYPES.MOBILE;
    } else if (device.television()) {
        return DEVICE_TYPES.TELEVISION;
    }

    return DEVICE_TYPES.DESKTOP;
})();

export let orientation = (() => {
    device.onChangeOrientation(orr => orientation = orr);

    if (device.portrait()) {
        return ORIENTATIONS.PORTRAIT;
    }

    return ORIENTATIONS.LANDSCAPE;
})();

export const inCrossDomainIframe = (() => {
    try {
        return (
            window !== window.parent &&
            window.location.origin !== window.parent.location.origin
        )
    } catch(e) {
        // accessing window.parent.location.origin will throw an exception
        return true;
    }

    return false;
})();

export const inHapYakTools = () => {
    // Detect if the player is embedded within any part of HapYak Tools
    return insideIFrame() && HY_TOOLS_MATCHER.test(document.referrer);
};

export const getViewportWidth = () => document && document.documentElement && document.documentElement.clientWidth;

export const getViewportHeight = () => document && document.documentElement && document.documentElement.clientHeight;

export const getLanguage = () => (document && document.documentElement && document.documentElement.lang) || 'en';

// from https://gomakethings.com/how-to-check-if-a-browser-supports-native-input-date-pickers
// MIT License
// Copyright © Chris Ferdinandi
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the “Software”), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
export const supportsDateInput = (() => {
    const inputEl = document.createElement('input'),
        notDateVal = 'a';

    inputEl.setAttribute('type', 'date');
    inputEl.setAttribute('value', notDateVal);

     // if an unsupported value is set on a date input on a browser that supports it, it will change the value to a supported value
    return inputEl.value !== notDateVal;
})();

export const getQuizEndpoint = (currentGroup = '') => {
    return QUIZ_ENDPOINTS.NEWSELA;
}
